"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Input_1 = require("../Input");
var Cell_1 = require("../Cell");
var Split_1 = require("../Split");
var Label = (0, styled_components_1.default)(Cell_1.Cell).attrs({ as: "label" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  user-select: none;\n"], ["\n  user-select: none;\n"])));
var Field = function (_a) {
    var label = _a.label, _b = _a.direction, direction = _b === void 0 ? "horizontal" : _b, props = __rest(_a, ["label", "direction"]);
    if ("input" in props) {
        var input = props.input, rest_1 = __rest(props, ["input"]);
        return (react_1.default.createElement(Split_1.Split, __assign({ direction: direction }, rest_1),
            react_1.default.createElement(Label, null, label),
            react_1.default.createElement(FieldInput, __assign({ width: "100%" }, input))));
    }
    var children = props.children, rest = __rest(props, ["children"]);
    return (react_1.default.createElement(Split_1.Split, __assign({ direction: direction }, rest),
        react_1.default.createElement(Label, null, label),
        react_1.default.createElement(react_1.default.Fragment, null, children)));
};
exports.Field = Field;
exports.Field.displayName = "Field";
var FieldInput = (0, styled_components_1.default)(Input_1.Input)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &[type=\"date\"] {\n    padding-top: 0;\n    padding-bottom: 0;\n    height: 100%;\n  }\n"], ["\n  &[type=\"date\"] {\n    padding-top: 0;\n    padding-bottom: 0;\n    height: 100%;\n  }\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=Field.js.map